import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
const RECENT_UNITS_KEY = "iwork-recent-units";
const RECENT_UNITS_LIMIT = 10;
export function getRecentUnits() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_UNITS_KEY) || "[]");
  } catch (error) {
    return [];
  }
}
export function setRecentUnits(units) {
  localStorage.setItem(RECENT_UNITS_KEY, JSON.stringify(units));
}
function normalizeUnit(unit) {
  if (!unit || !unit.unitId) return null;
  return {
    unitId: unit.unitId,
    name: unit.name,
    code: unit.code,
    type: unit.type,
    icon: unit.icon
  };
}
export function pushRecentUnit(unit) {
  const normalizedUnit = normalizeUnit(unit);
  if (!normalizedUnit) return getRecentUnits();
  const nextUnits = getRecentUnits().filter(item => item.unitId !== normalizedUnit.unitId);
  nextUnits.unshift(normalizedUnit);
  const limitedUnits = nextUnits.slice(0, RECENT_UNITS_LIMIT);
  setRecentUnits(limitedUnits);
  return limitedUnits;
}